/* ============================================================
   AHA COUTURE — theme.js
   Bespoke commerce + interactions (vanilla, no framework).
   Cart uses Shopify AJAX Cart API + Section Rendering API.
   ============================================================ */
(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var routes = window.AHA && window.AHA.routes ? window.AHA.routes : { cart_add: '/cart/add', cart_change: '/cart/change', cart: '/cart' };
  var strings = (window.AHA && window.AHA.strings) || {};

  /* ---------- helpers ---------- */
  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function on(el, ev, fn, o) { el && el.addEventListener(ev, fn, o); }
  function formatMoney(cents) {
    var fmt = (window.AHA && window.AHA.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  /* ---------- Cart ---------- */
  var Cart = {
    async add(formData) {
      formData.append('sections', 'cart-drawer,cart-bubble');
      var res = await fetch(routes.cart_add + '.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      var data = await res.json();
      if (!res.ok) throw data;
      this.renderSections(data.sections);
      return data;
    },
    async change(line, quantity) {
      var res = await fetch(routes.cart_change + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer,cart-bubble' })
      });
      var data = await res.json();
      this.renderSections(data.sections);
      return data;
    },
    renderSections(sections) {
      if (!sections) return;
      var wasOpen = document.body.classList.contains('drawer-open');
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (typeof html !== 'string') return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-section="' + id + '"]') || doc.body.firstElementChild;
        var current = qs('[data-section="' + id + '"]');
        if (incoming && current) current.replaceWith(incoming);
      });
      bindCartUI();
      // Preserve the drawer's open state across Section Rendering swaps
      if (wasOpen) {
        var d = qs('[data-cart-drawer]');
        if (d) { d.removeAttribute('hidden'); d.classList.add('is-open'); document.body.classList.add('drawer-open'); }
      }
    }
  };

  /* ---------- Cart drawer open/close ---------- */
  var drawer = null;
  function openDrawer() {
    drawer = qs('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.removeAttribute('hidden');
    document.body.classList.add('drawer-open');
    var focusable = qs('button, a, [tabindex]', drawer);
    focusable && focusable.focus();
  }
  function closeDrawer() {
    drawer = qs('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.setAttribute('hidden', ''); }, 400);
  }

  function bindCartUI() {
    qsa('[data-cart-close]').forEach(function (b) { on(b, 'click', closeDrawer); });
    qsa('[data-qty-change]').forEach(function (btn) {
      on(btn, 'click', async function () {
        var line = +btn.getAttribute('data-line');
        var qty = +btn.getAttribute('data-qty');
        var inDrawer = !!btn.closest('[data-cart-drawer]');
        if (inDrawer) btn.closest('[data-cart-drawer]').classList.add('is-loading');
        try { await Cart.change(line, qty); if (inDrawer) openDrawer(); } catch (e) {}
      });
    });
    qsa('[data-qty-input]').forEach(function (inp) {
      on(inp, 'change', async function () {
        var line = +inp.getAttribute('data-line');
        var qty = Math.max(0, parseInt(inp.value, 10) || 0);
        var inDrawer = !!inp.closest('[data-cart-drawer]');
        try { await Cart.change(line, qty); if (inDrawer) openDrawer(); } catch (e) {}
      });
    });
  }

  /* ---------- Product form (add to cart) ---------- */
  function bindProductForms() {
    qsa('form[data-product-form]').forEach(function (form) {
      if (form.__bound) return; form.__bound = true;
      on(form, 'submit', async function (e) {
        e.preventDefault();
        var btn = qs('[data-add-to-cart]', form);
        var errEl = qs('[data-form-error]', form);
        if (btn) { btn.classList.add('is-loading'); btn.setAttribute('disabled', ''); }
        errEl && (errEl.hidden = true);
        try {
          await Cart.add(new FormData(form));
          openDrawer();
        } catch (err) {
          if (errEl) { errEl.textContent = (err && err.description) || strings.addError || 'No se pudo agregar.'; errEl.hidden = false; }
        } finally {
          if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('disabled'); }
        }
      });
    });
  }

  /* ---------- Variant picker ---------- */
  function bindVariantPickers() {
    qsa('[data-variant-picker]').forEach(function (picker) {
      if (picker.__bound) return; picker.__bound = true;
      var dataEl = qs('[data-variant-json]', picker);
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
      var form = picker.closest('form[data-product-form]') || qs('form[data-product-form][data-product-id="' + picker.getAttribute('data-product-id') + '"]');
      function selectedOptions() {
        return qsa('[data-option-index]', picker).map(function (group) {
          var checked = qs('input:checked', group) || qs('select', group);
          return checked ? checked.value : null;
        });
      }
      function update() {
        var opts = selectedOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        var idInput = form ? qs('[data-variant-id]', form) : null;
        var priceEl = qs('[data-product-price]', document);
        var addBtn = form ? qs('[data-add-to-cart]', form) : null;
        if (match) {
          if (idInput) idInput.value = match.id;
          if (priceEl) priceEl.innerHTML = formatMoney(match.price);
          if (addBtn) {
            addBtn.disabled = !match.available;
            var t = qs('[data-add-text]', addBtn) || addBtn;
            t.textContent = match.available ? (strings.addToCart || 'Agregar al carrito') : (strings.soldOut || 'Agotado');
          }
          if (match.featured_media) {
            var g = qs('[data-gallery]');
            if (g) {
              var target = qs('[data-media-id="' + match.featured_media.id + '"]', g);
              if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
            }
          }
          if (history.replaceState) {
            var url = new URL(window.location);
            url.searchParams.set('variant', match.id);
            history.replaceState({}, '', url);
          }
        } else if (addBtn) {
          addBtn.disabled = true;
          var t2 = qs('[data-add-text]', addBtn) || addBtn;
          t2.textContent = strings.unavailable || 'No disponible';
        }
      }
      qsa('input, select', picker).forEach(function (i) { on(i, 'change', update); });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function bindQtySteppers() {
    qsa('[data-qty-stepper]').forEach(function (wrap) {
      if (wrap.__bound) return; wrap.__bound = true;
      var input = qs('input', wrap);
      qsa('[data-step]', wrap).forEach(function (b) {
        on(b, 'click', function () {
          var step = +b.getAttribute('data-step');
          var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Header: menu + cart open + scroll state ---------- */
  function bindHeader() {
    qsa('[data-cart-open]').forEach(function (b) {
      on(b, 'click', function (e) { e.preventDefault(); openDrawer(); });
    });
    var toggle = qs('[data-menu-toggle]');
    var menu = qs('[data-mobile-menu]');
    if (toggle && menu) {
      on(toggle, 'click', function () {
        var open = menu.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('menu-open', open);
      });
      qsa('[data-menu-close]', menu).forEach(function (b) { on(b, 'click', function () { menu.classList.remove('is-open'); document.body.classList.remove('menu-open'); toggle.setAttribute('aria-expanded', 'false'); }); });
    }
    var header = qs('[data-header]');
    if (header) {
      var onScrollHeader = function () { header.classList.toggle('is-scrolled', getScrollTop() > 40); };
      document.addEventListener('scroll', onScrollHeader, true);
      onScrollHeader();
    }
    on(document, 'keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); menu && menu.classList.remove('is-open'); document.body.classList.remove('menu-open'); } });
  }

  function getScrollTop() {
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  /* ---------- Motion: reveal + parallax (scroller-agnostic) ---------- */
  var revealNodes = [], parNodes = [], ticking = false;
  function collectMotion() {
    revealNodes = qsa('.reveal:not(.in)');
    parNodes = qsa('[data-parallax]');
  }
  function motionFrame() {
    ticking = false;
    var vh = window.innerHeight || root.clientHeight;
    for (var i = revealNodes.length - 1; i >= 0; i--) {
      var r = revealNodes[i].getBoundingClientRect();
      if (r.top < vh * 0.9 && r.bottom > vh * -0.2) { revealNodes[i].classList.add('in'); revealNodes.splice(i, 1); }
    }
    if (!reduce) {
      for (var j = 0; j < parNodes.length; j++) {
        var p = parNodes[j], pr = p.getBoundingClientRect();
        if (pr.bottom < -100 || pr.top > vh + 100) continue;
        var offset = pr.top + pr.height / 2 - vh / 2;
        var max = pr.height * 0.09;
        var shift = Math.max(-max, Math.min(max, -offset * (parseFloat(p.getAttribute('data-parallax')) || 0.12)));
        p.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0) scale(1.2)';
      }
    }
  }
  function onMotion() { if (!ticking) { ticking = true; requestAnimationFrame(motionFrame); } }
  function initMotion() {
    collectMotion();
    if (reduce) { revealNodes.forEach(function (n) { n.classList.add('in'); }); }
    motionFrame();
    document.addEventListener('scroll', onMotion, true);
    window.addEventListener('resize', onMotion, { passive: true });
    window.addEventListener('load', onMotion);
  }

  /* ---------- init ---------- */
  function init() {
    bindHeader();
    bindProductForms();
    bindVariantPickers();
    bindQtySteppers();
    bindCartUI();
    initMotion();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () { init(); collectMotion(); motionFrame(); });

  window.AHA = window.AHA || {};
  window.AHA.cart = Cart;
  window.AHA.openDrawer = openDrawer;
})();
